"use client";

import { useVenuePageTheme } from "../../hooks";
import VenueSubscriptionBanner, {
  type VenueSubscriptionBannerProps,
} from "./VenueSubscriptionBanner";
import { lightenColor } from "@punchup/utils/colors";

interface VenueSubscriptionBannerThemedProps extends Omit<
  VenueSubscriptionBannerProps,
  "bannerColor" | "buttonLabelColor" | "buttonBackgroundColor"
> {}

export default function VenueSubscriptionBannerThemed({
  venue,
  ...rest
}: VenueSubscriptionBannerThemedProps) {
  const { accentColor, buttonLabelColor } = useVenuePageTheme(venue.slug);
  return (
    <VenueSubscriptionBanner
      venue={venue}
      {...rest}
      // append the relevant color for this venue
      bannerColor={lightenColor(accentColor, 0.9)}
      buttonLabelColor={buttonLabelColor}
      buttonBackgroundColor={accentColor}
    />
  );
}
